import axios from '@/util/request';

// 规范库列表
export function GetList(parameter) {
  return axios({
    url: '/ims/standard/page',
    method: 'get',
    params: parameter,
  })
}
// 新增规范
export function addCompany(parameter) {
  return axios({
    url: '/ims/standard',
    method: 'post',
    data: parameter,
  })
}
// 更新规范
export function updateCompany(parameter) {
  return axios({
    url: '/ims/standard',
    method: 'put',
    data: parameter,
  })
}
// 通过id删除规范
export function delCompany(id) {
  return axios({
    url: '/ims/standard/delete/' + id,
    method: 'DELETE'
  })
}

export function GetNormalIns(parameter) {
  return axios({
    url: '/ims/instrument/GetNormalIns',
    method: 'get',
    params: parameter,
  })
}

export function GetVsList(parameter) {
  return axios({
    url: '/ims/standard/getAllVersion',
    method: 'get',
    params: parameter
  })
}

export function addVs(parameter) {
  return axios({
    url: '/ims/standardversion',
    method: 'post',
    data: parameter,
  })
}

export function updateVs(parameter) {
  return axios({
    url: '/ims/standardversion',
    method: 'put',
    data: parameter,
  })
}

export function delVs(id) {
  return axios({
    url: '/ims/standardversion/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/Standard.js